import React, { useEffect, useState } from 'react';
import './Varmesystem.css'; // Assuming you want to style it via CSS
import { useSpring, animated } from 'react-spring'; // Importing react-spring
import myHeatExchangerImage from './assets/HeatExchanger.png';  // Import the image
import myPumpImage from './assets/pump.png';  // Import the image
import myCompressorImage from './assets/compressor.png';  // Import the image
import mytillskottImage from './assets/HeatCoil.png';  // Import the image
import myRadiatorImage from './assets/radiator.png';  // Import the image
import myThreeValueImage from './assets/Threewayvalve.png';  // Import the image
import myVarmWaterHeaterImage from './assets/VarmvattenberedareNew.png';  // Import the image
import myGolvVarmeImage from './assets/FloorHeating.png';  // Import the image
import myHusImage from './assets/hus.png';  // Import the image
import myBatteriImage from './assets/batteri.png';  // Import the image
import myInverterImage from './assets/InverterNy.png';  // Import the image
import myTransmissonImage from './assets/electric-tower.png';  // Import the image
import myElmeterImage from './assets/elmeter.png';  // Import the image
const VärmesystemScreen = () => { 

    const [effectData, setEffectData] = useState({
        solEffect: 0,
        batteriEffect: 0,
        husEffect: 0,
        nätEffect: 0,
    });

    const [valueData, setValueData] = useState({
        kompressor: "OFF",
        stopV: 0,
        borV: 0,
        startV: 0,
        tillskott6: "OFF",
        vxl: "RV",
        tillskott3: "OFF",
        framledTemp: 0,
        varmVattenTemp: 0,
        inneTemp: 0,
        uteTemp:0,
        radPump:"OFF",
        golvPump:"OFF",
        varmePump:"OFF",
        koldPump:"OFF",
        golvTemp:0,
        varmeTempIn:0,
        varmeTempUt:0,
        koldTempIn:0,
        koldTempUt:0,
        hetGas:0,
        startVatten:0,
        stoppVatten:0,
        varmepumpStatus:"OFF"
    });

  useEffect(() => {
    const fetchData = () => {
      fetch('/varmepumpsData')
        .then(response => response.json())
        .then(json => {
          try {

            setEffectData({
                solEffect: json[0]?.Soleffekt || 0,
                batteriEffect: json[0]?.Batterieffekt || 0,
                husEffect: json[0]?.Huseffekt || 0,
                nätEffect: json[0]?.Näteffekt || 0,
              });
            setValueData({
              kompressor: json[0]?.KompressorStatus || "OFF",
              framledTemp: json[0]?.FramLedTemp || 0,
              borV: json[0]?.Börvärde || 0,
              startV:json[0]?.Startvärde || 0,
              stopV: json[0]?.Stoppvärde || 0,
              tillskott3: json[0]?.Tillskott3kWStatus || "OFF",
              tillskott6: json[0]?.Tillskott6kWStatus || "OFF",
              uteTemp: json[0]?.Utetemp || 0,
              inneTemp: json[0]?.InneTemp || 0,
              vxl: json[0]?.VäxelVentil || "RV",
              varmeTempIn: json[0]?.VBInTemp || 0,
              varmeTempUt: json[0]?.VBUtTemp || 0,
              varmVattenTemp: json[0]?.VarmvattenTemp || 0,
              startVatten:json[0]?.StartvärdeVV || 0,
              stoppVatten:json[0]?.StoppvärdeVV || 0,
              radPump:json[0]?.RadPump || "OFF",
              varmePump:json[0]?.VärmePump || "OFF",
              koldPump:json[0]?.KöldPump || "OFF",
              golvPump:json[0]?.GolvPump || "OFF",
              golvTemp:json[0]?.GolvTemp || 0,
              koldTempIn:json[0]?.KöldTempIn || 0,
              koldTempUt:json[0]?.KöldTempUt || 0,
              hetGas:json[0]?.Hetgas || 0,
              varmepumpStatus:json[0]?.VärmepumpsStatus || "OFF",
            });

          } catch (error) {
            console.error('Failed to parse JSON:', error);
          }
        })
        .catch(error => console.error('Fetch error:', error));
    };

    fetchData();
    const intervalId = setInterval(fetchData, 6000);
    return () => clearInterval(intervalId);
  }, []);

     const getEffectDirection = (effect) => {
    if (effect > 0) {
        return 1000; // Positive effect: animate in one direction
        } else if (effect < 0) {
        return -1000; // Negative effect: animate in the opposite direction
        }
        return 0; // No effect: stop animation
     };

    const getDirection = (value) => {
      if ( value === "ON") {
        return 2000; // Positive effect: animate in one direction
      } else  {
        return 0; // Negative effect: animate in the opposite direction
      }
    };

    const getDirectionValveVatten = (value,value1) => {
      if ( value === "ON" && value1 === "VV") {
        return 2000; // Positive effect: animate in one direction
      } else  {
        return 0; // Negative effect: animate in the opposite direction
      }
    };

    const getDirectionValueRad = (value,value1) => {
        if ( value === "ON" && value1 === "RV") {
          return 2000; // Positive effect: animate in one direction
        } else  {
          return 0; // Negative effect: animate in the opposite direction
        }
      };
    
    const blueLineCompressorSpring = useSpring({
        strokeDashoffset: getDirection(valueData.kompressor),
        config: { duration: 65000 },
        reset: true,
        from: { strokeDashoffset: 0 },
        to: { strokeDashoffset: getDirection(valueData.kompressor) },
      });
  
    const blueLineColdSpring = useSpring({
      strokeDashoffset: getDirection(valueData.koldPump),
      config: { duration: 65000 },
      reset: true,
      from: { strokeDashoffset: 0 },
      to: { strokeDashoffset:  getDirection(valueData.koldPump) },
    });

    const blueLineVarmeBarareSpring = useSpring({
        strokeDashoffset: getDirection(valueData.varmePump),
        config: { duration: 65000 },
        reset: true,
        from: { strokeDashoffset: 0 },
        to: { strokeDashoffset:  getDirection(valueData.varmePump) },
      });

    const redMoveColdPathSpring = useSpring({
        strokeDashoffset: getDirection(valueData.koldPump),
        config: { duration: 65000 },
        reset: true,
        from: { strokeDashoffset: getDirection(valueData.koldPump) },
        to: { strokeDashoffset: 0 },
      });

    const redMoveCompressorPathSpring = useSpring({
        strokeDashoffset: getDirection(valueData.kompressor),
        config: { duration: 65000 },
        reset: true,
        from: { strokeDashoffset: getDirection(valueData.kompressor) },
        to: { strokeDashoffset: 0 },
     });

    const redMoveVarmeBararePathSpring = useSpring({
        strokeDashoffset: getDirection(valueData.varmePump),
        config: { duration: 65000 },
        reset: true,
        from: { strokeDashoffset: getDirection(valueData.varmePump)},
        to: { strokeDashoffset: 0 },
     });

    const redMoveVarmeBarareVattenPathSpring = useSpring({
        strokeDashoffset: getDirectionValveVatten(valueData.varmePump, valueData.vxl),
        config: { duration: 65000 },
        reset: true,
        from: { strokeDashoffset: getDirectionValveVatten(valueData.varmePump, valueData.vxl) },
        to: { strokeDashoffset: 0 },
     });

    const blueMoveVarmeBarareVattenPathSpring = useSpring({
        strokeDashoffset: getDirectionValveVatten(valueData.varmePump, valueData.vxl),
        config: { duration: 65000 },
        reset: true,
        from: { strokeDashoffset: 0 },
        to: { strokeDashoffset: getDirectionValveVatten(valueData.varmePump, valueData.vxl) },
     });
    
    const redMoveVarmeBarareFramledPathSpring = useSpring({
        strokeDashoffset: getDirectionValueRad(valueData.radPump,valueData.vxl),
        config: { duration: 65000 },
        reset: true,
        from: { strokeDashoffset: getDirectionValueRad(valueData.radPump,valueData.vxl) },
        to: { strokeDashoffset:  0},
     });

    const blueMoveVarmeBarareFramledPathSpring = useSpring({
        strokeDashoffset: getDirectionValueRad(valueData.radPump,valueData.vxl),
        config: { duration: 65000 },
        reset: true,
        from: { strokeDashoffset: 0 },
        to: { strokeDashoffset: getDirectionValueRad(valueData.radPump,valueData.vxl)},
     });
    
    const redMoveGolvPathSpring = useSpring({
        strokeDashoffset: getDirectionValueRad(valueData.golvPump,valueData.vxl),
        config: { duration: 65000 },
        reset: true,
        from: { strokeDashoffset: getDirectionValueRad(valueData.golvPump,valueData.vxl) },
        to: { strokeDashoffset: 0},
     });
    
    const blueMoveGolvPathSpring = useSpring({
        strokeDashoffset: getDirectionValueRad(valueData.golvPump,valueData.vxl),
        config: { duration: 65000 },
        reset: true,
        from: { strokeDashoffset:  0},
        to: { strokeDashoffset: getDirectionValueRad(valueData.golvPump,valueData.vxl)},
     });
    
     const golvRotation = useSpring({
        to: { transform: valueData.golvPump ==="ON" ? 'rotate(360deg)' : 'rotate(0deg)' },
        from:{transform: 'rotate(0deg)'},
        config: { duration: 2000 },
        loop: valueData.golvPump ==="ON",
      });

      const radRotation = useSpring({
        to: { transform: valueData.radPump ==="ON" ? 'rotate(0deg)' : 'rotate(360deg)' },
        from:{transform: 'rotate(360deg)'},
        config: { duration: 2000 },
        loop: valueData.radPump ==="ON",
      });

      const varmeRotation = useSpring({
        to: { transform: valueData.varmePump ==="ON" ? 'rotate(0deg)' : 'rotate(360deg)' },
        from:{transform: 'rotate(360deg)'},
        config: { duration: 2000 },
        loop: valueData.varmePump ==="ON",
      });

      const koldRotation = useSpring({
        to: { transform: valueData.koldPump ==="ON" ? 'rotate(360deg)' : 'rotate(0deg)' },
        from:{transform: 'rotate(0deg)'},
        config: { duration: 2000 },
        loop: valueData.koldPump ==="ON",
      });

      const kompressorRotation = useSpring({
        to: { transform: valueData.kompressor ==="ON" ? 'rotate(360deg)' : 'rotate(0deg)' },
        from:{transform: 'rotate(0deg)'},
        config: { duration: 2000 },
        loop: valueData.kompressor ==="ON",
      });
      
      const solPathSpring = useSpring({
        strokeDashoffset: getEffectDirection(effectData.solEffect),
        config: { duration: 65000 },
        reset: true,
        from: { strokeDashoffset: getEffectDirection(effectData.solEffect) },
        to: { strokeDashoffset: 0},
     });

     const batteriLineSpring = useSpring({
        strokeDashoffset: getEffectDirection(effectData.batteriEffect),
        config: { duration: 65000 },
        reset: true,
        from: { strokeDashoffset: getEffectDirection(effectData.batteriEffect) },
        to: { strokeDashoffset: 0},
     });

     const nätLineSpring = useSpring({
        strokeDashoffset: getEffectDirection(-effectData.nätEffect),
        config: { duration: 65000 },
        reset: true,
        from: { strokeDashoffset: getEffectDirection(-effectData.nätEffect) },
        to: { strokeDashoffset: 0},
     });

     const husLineSpring = useSpring({
        strokeDashoffset: getEffectDirection(effectData.husEffect),
        config: { duration: 65000 },
        reset: true,
        from: { strokeDashoffset: getEffectDirection(effectData.husEffect) },
        to: { strokeDashoffset: 0},
     });

  return (
    <div>
    <h1>Värme System</h1>
     <div className="fullVarmeContainer">
        <div className = 'svgVarmeWrapper'>
            <svg className='svgVarmeContainer'viewBox='0 0 1850 940' preserveAspectRatio="xMidYMid meet">
               <animated.line
                    x1="6%" y1="65%" x2="32%" y2="65%"
                    stroke="blue"
                    strokeWidth="5"
                    strokeDasharray="5,5"
                    strokeDashoffset={blueLineColdSpring.strokeDashoffset}
                />
                <animated.line
                    x1="59%" y1="65%" x2="71%" y2="65%"
                    stroke="blue"
                    strokeWidth="5"
                    strokeDasharray="5,5"
                    strokeDashoffset={blueLineVarmeBarareSpring.strokeDashoffset}
                />
                <animated.line
                    x1="32%" y1="65%" x2="55%" y2="65%"
                    stroke="blue"
                    strokeWidth="5"
                    strokeDasharray="5,5"
                    strokeDashoffset={blueLineCompressorSpring.strokeDashoffset}
                />
                <animated.path 
                    d="M115 420 L500 420 L500 555 L560 555"
                    fill="none" 
                    stroke="red" 
                    strokeWidth="5"  
                    strokeDasharray="5,5"
                    strokeDashoffset={redMoveColdPathSpring.strokeDashoffset}
                />
                <animated.path 
                    d="M620 555 L680 555 L680 420 L980 420 L980 555 L1100 555"
                    fill="none" 
                    stroke="red" 
                    strokeWidth="5"  
                    strokeDasharray="5,5"
                    strokeDashoffset={redMoveCompressorPathSpring.strokeDashoffset} 
                />
                 <animated.path 
                    d="M1100 555 L1132 555 L1132 210"
                    fill="none" 
                    stroke="red" 
                    strokeWidth="5"  
                    strokeDasharray="5,5" 
                    strokeDashoffset={redMoveVarmeBararePathSpring.strokeDashoffset} 
                />
                 <animated.path 
                    d="M1120 175 L1325 175 L1325 290 L1400 290"
                    fill="none" 
                    stroke="red" 
                    strokeWidth="5"  
                    strokeDasharray="5,5" 
                    strokeDashoffset={redMoveVarmeBarareVattenPathSpring.strokeDashoffset} 
                />                
                 <animated.path 
                    d="M1100 175 L700 175 L700 125 L900 125"
                    fill="none" 
                    stroke="red" 
                    strokeWidth="5"  
                    strokeDasharray="5,5"
                    strokeDashoffset={redMoveVarmeBarareFramledPathSpring.strokeDashoffset}  
                />
                 <animated.path 
                    d="M1325 610 L1600 610 L1600 125 L900 125"
                    fill="none" 
                    stroke="blue" 
                    strokeWidth="5"  
                    strokeDasharray="5,5"
                    strokeDashoffset={blueMoveVarmeBarareFramledPathSpring.strokeDashoffset}   
                />                
                 <animated.path 
                    d="M1325 610 L1325 385 L1400 385"
                    fill="none" 
                    stroke="blue" 
                    strokeWidth="5"  
                    strokeDasharray="5,5" 
                    strokeDashoffset={blueMoveVarmeBarareVattenPathSpring.strokeDashoffset} 
                />
                 <animated.path 
                    d="M700 125 L700 75 L1200 75"
                    fill="none" 
                    stroke="red" 
                    strokeWidth="5"  
                    strokeDasharray="5,5"
                    strokeDashoffset={redMoveGolvPathSpring.strokeDashoffset}  
                />
                 <animated.path 
                    d="M1260 125 L1260 75 L1200 75"
                    fill="none" 
                    stroke="blue" 
                    strokeWidth="5"  
                    strokeDasharray="5,5"
                    strokeDashoffset={blueMoveGolvPathSpring.strokeDashoffset}   
                />
                <defs>
                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" style={{stopColor: 'red', stopOpacity:1}} />
                    <stop offset="100%" style={{stopColor: 'blue', stopOpacity:1}} />
                    </linearGradient>
                </defs>                                                                                
                <animated.path
                    d="M80 50 C 40 50, 40 60, 80 70 S 120 80, 80 90 S 40 100, 80 110 S 120 120, 80 130 S 40 140, 80 150 S 120 160, 80 170 S 40 180, 80 190 S 120 200, 80 210 S 40 230, 80 240 "
                    stroke="url(#gradient1)"
                    strokeWidth="5"
                    strokeDasharray="5,5"
                    strokeDashoffset={blueLineColdSpring.strokeDashoffset}
                    fill="transparent"
                    transform="translate(30, 370)" // Adjust the second value to move the curve down
               />
            </svg>
            <div className='heatExchangeColdContainer'>
                <img 
                className = 'heatExchangeColdImage'
                src={myHeatExchangerImage} 
                alt="VärmeVäxlare"
                />   
            </div>
            <div className='heatExchangeVarmContainer'>
                <img
                className = 'heatExchangeVarmImage'
                src={myHeatExchangerImage} 
                alt="VärmeVäxlare" 
                /> 
            </div>
            <div className='coldInPumpContainer'>
                <animated.img
                    className ='coldInPumpImage'
                    src={myPumpImage} 
                    alt="Pump"
                    style={koldRotation}
                />
            </div>
            <div className='compressorContainer'>
                <animated.img
                    className='compressorImage'
                    src={myCompressorImage} 
                    alt="Comprssor" 
                    style={kompressorRotation}
                />
            </div>
            <div className='kW3TillSkottContainer'>
                <img
                    className='kW3TillSkottImage'
                    src={mytillskottImage} 
                    alt="3kWTillskott" 
                />
            </div>
            <div className='kW6TillSkottContainer'>
                <img
                    className='kW6TillSkottImage'
                    src={mytillskottImage} 
                    alt="6kWTillskott" 
                />
            </div>
            <div className="radiatorVarmeContainer">
            <img
                className="radiatorVarmeImage" 
                src={myRadiatorImage} 
                alt="Radiator" 
            />
            </div>
            <div className="golvVarmeContainer">
            <img
                className="golvVarmeImage"
                src={myGolvVarmeImage} 
                alt="GolvVärme" 
            />
            </div>        
            <div className='radPumpContainer'>
                <animated.img
                   className='radPumpImage' 
                   src={myPumpImage} 
                   alt="Pump" 
                   style={radRotation}
                />
            </div>
            <div className='golvPumpContainer'>
                <animated.img
                    className='golvPumpImage'
                    src={myPumpImage} 
                    alt="Pump" 
                    style={golvRotation}
                />

            </div>
            <div className='vBPumpContainer'>
                <animated.img
                    className='vBPumpImage'
                    src={myPumpImage} 
                    alt="Pump" 
                    style={varmeRotation} 
                />
            </div>        
            <div className='threeWayValveContainer'>
                <img
                    className='threeWayValveImage'
                    src={myThreeValueImage} 
                    alt="ThreeWayValue" 
                />
            </div>
            <div className='varmWaterHeaterContainer'>
                <img
                    className = 'varmWaterHeaterImage'
                    src={myVarmWaterHeaterImage} 
                    alt="VarmWaterHeater" 
                />
            </div>
            <div className="boxVarmeVatten">
                <p className='boxVarmeText' >Varmvatten temp</p>
                <p className='boxVarmeText'>{(valueData?.varmVattenTemp) || 0} C</p>
                <p className='boxVarmeText' >Startvärde</p>
                <p className='boxVarmeText'>{(valueData?.startVatten) || 0} C</p>
                <p className='boxVarmeText' >Stoppvärde</p>
                <p className='boxVarmeText'>{(valueData?.stoppVatten) || 0} C</p>
            </div>     
            <div className="boxVarmeBUt">
                <p className='boxVarmeText' >VB Ut temp</p>
                <p className='boxVarmeText'>{(valueData?.varmeTempUt) || 0} C</p>
            </div>
            <div className="boxVarmeBIn">
                <p className='boxVarmeText' >VB In temp</p>
                <p className='boxVarmeText'>{(valueData?.varmeTempIn) || 0} C</p>   
            </div>                  
            <div className="boxFramled">
                <p className='boxVarmeText' >Framledning temp</p>
                <p className='boxVarmeText'>{(valueData?.framledTemp) || 0} C</p>   
            </div>
            <div className="boxGolvled">
                <p className='boxVarmeText' >golv temp</p>
                <p className='boxVarmeText'>{(valueData?.golvTemp) || 0} C</p>    
            </div>                                   
            <div className="boxCompressor">
                <p className='boxVarmeText' >Hetgas</p>
                <p className='boxVarmeText'>{(valueData?.hetGas) || 0} C</p>
            </div>
            <div className="boxColdIn">
                <p className='boxVarmeText' >KB In temp</p>
                <p className='boxVarmeText'>{(valueData?.koldTempIn) || 0} C</p>
            </div>
            <div className="boxColdUt">
                <p className='boxVarmeText' >KB Ut temp</p>
                <p className='boxVarmeText'>{(valueData?.koldTempUt) || 0} C</p>
            </div>
            <div className="boxVarmepumpStatus">
                <p className='boxVarmeText' >Värmesystemsstatus</p>
                <p className='boxVarmeText'>{(valueData?.varmepumpStatus) || "OFF"} </p>
            </div>
            <div className="boxBorVarde">
                <p className='boxVarmeText' >Startvärde</p>
                <p className='boxVarmeText'>{(valueData?.startV) || 0} C</p>
                <p className='boxVarmeText' >Börvärde</p>
                <p className='boxVarmeText'>{(valueData?.borV) || 0} C</p>
                <p className='boxVarmeText' >Stoppvärde</p>
                <p className='boxVarmeText'>{(valueData?.stopV) || 0} C</p>
            </div>
            <div className="box6kW">
                   <p className='boxVarmeText'>6kW</p>
            </div>
            <div className='box6kWOnOff'>
                   <p className='boxVarmeText'>{(valueData?.tillskott6) || "OFF"}</p>
            </div>
            <div className="box3kW">
                   <p className='boxVarmeText'>3kW</p>
            </div>
            <div className="box3kWOnOff">
                   <p className='boxVarmeText'>{(valueData?.tillskott3) || "OFF"}</p>
            </div>
        </div>      
            <svg className = "svgSolContainer"  viewBox='0 0 1000 970' preserveAspectRatio="xMidYMid meet">
                    <animated.path 
                        d="M190 70 L185 90 L150 125 L190 180 L280 180"
                        fill="none" 
                        stroke="orange" 
                        strokeWidth="5"  
                        strokeDasharray="5,5" 
                        strokeDashoffset={solPathSpring.strokeDashoffset} 
                    />
                    <animated.line
                    x1="30%" y1="15%" x2="30%" y2="30%"
                    stroke="green"
                    strokeWidth="5"
                    strokeDasharray="5,5"
                    strokeDashoffset={batteriLineSpring.strokeDashoffset}
                    />
                    <animated.line
                    x1="16%" y1="22%" x2="28%" y2="18.5%"
                    stroke="blue"
                    strokeWidth="5"
                    strokeDasharray="5,5"
                    strokeDashoffset={nätLineSpring.strokeDashoffset}
                    />
                    
                    <animated.line
                    x1="32%" y1="17%" x2="45%" y2="17%"
                    stroke="red"
                    strokeWidth="5"
                    strokeDasharray="5,5"
                    strokeDashoffset={husLineSpring.strokeDashoffset}
                    />
            </svg>
            <div className='husContainer'>
                <img
                    className ='husImage'
                    src={myHusImage} 
                    alt="Hus" 
                />
            </div>
            <div className='batteriHusContainer'>
                <img
                    className ='batteriHusImage'
                    src={myBatteriImage} 
                    alt="Batteri" 
                />
            </div>
            <div className='inverterHusContainer'>
                <img
                    className='inverterHusImage'
                    src={myInverterImage} 
                    alt="Inverter" 
                />
            </div>
            <div className='transmissionHusContainer'>
                <img
                    className='transmissionHusImage'
                    src={myTransmissonImage} 
                    alt="electric-tower" 
                />
            </div>
            <div className='elmeterHusContainer'>
                <img
                    className='elmeterHusImage'
                    src={myElmeterImage} 
                    alt="elmeter" 
                />
            </div>
            <div className="boxUteTemp">
                <p className='boxVarmeText' >Ute temp</p>
                <p className='boxVarmeText'>{(valueData?.uteTemp) || 0} C</p>
            </div>
            <div className="boxInneTemp">
                <p className='boxVarmeText' >Inne temp</p>
                <p className='boxVarmeText'>{(valueData?.inneTemp) || 0} C</p>
            </div>     
            <div className="boxSolEffect">
                <p className='boxVarmeText' >Soleffekt</p>
                <p className='boxVarmeText'>{(effectData?.solEffect) || 0} W</p>
            </div>
            <div className="boxNätEffect">
                <p className='boxVarmeText' >Näteffekt</p>
                <p className='boxVarmeText'>{Math.abs(effectData?.nätEffect) || 0} W</p>
            </div>
            <div className="boxBatteriEffect">
                <p className='boxVarmeText' >Batterieffekt</p>
                <p className='boxVarmeText'>{Math.abs(effectData?.batteriEffect) || 0} W</p>
            </div>
            <div className="boxHusEffect">
                <p className='boxVarmeText' >Huseffekt</p>
                <p className='boxVarmeText'>{Math.abs(effectData?.husEffect) || 0} W</p>
            </div>
        
        </div>
    </div>
  )
};

export default VärmesystemScreen;